import React, { useState } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import LoginLogo from "../../assets/images/sidebar-logo-white.png";
import superAdminApis from "../../api/services/admin-pages/superAdmin";
import { toast } from "react-toastify";
import translations from "../../shared/Translations";

export default function LoginPage() {
 const [showPassword, setShowPassword] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const navigate = useNavigate();

  const regexValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

 const [lang, setLang] = useState("en");

   const t = (key) => translations[lang][key] || key;

const handleLangChange = (e) => {
  console.log(e);
  
  const selectedLang = e.target.value;
  setLang(selectedLang);
  localStorage.setItem("lang", selectedLang); 
};

  const adminLogin = async (e) => {
    e.preventDefault();
    setSubmit(true);
  // navigate('/customer-list');
    // Simple validation
    if (!userName.trim() || !password.trim()) {
      // toast.error('Please fill in all required fields.');
      return;
    }

    setLoading(true);

    const apiData = {
      loginType: 'admin',
      user_name: userName.trim(),
      password: password,
    };

    try {
      const responseData = await superAdminApis.superAdminLoginAPI(apiData);

      if (responseData.apiStatus?.code === '200') {
        const userDetail = responseData?.responseData?.userDetail?.userName;
        console.log(userDetail);
        


        localStorage.setItem('userName', userDetail || '');
        localStorage.setItem('roleName', userDetail?.roles?.roleName || '');
        localStorage.setItem('token', responseData.responseData?.token || '');
        localStorage.setItem('studentloginid', userDetail?.id || '');

         sessionStorage.setItem("showWelcome", "true");

        toast.success(responseData.apiStatus.message || 'Login successful!');
        navigate('/dashboard');
      } else {
        toast.error(responseData.apiStatus?.message || 'Login failed!');
      }

     


    } catch (error) {
      console.error('Error during login:', error);
      toast.error('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="page-center">
      <div className={`signIn-container container ${lang === "ta" ? "fs-tamil" : ""}`}>

        {/* SIGN IN */}
        <div className="form-container sign-in " >
          <form  className="p-4">
            <h3 >{t("signIn")}</h3>

<span className={`${lang === "ta" ? "fs-tamil subtitle-tamil" : ""}`}>
  {t("subtitle")}
</span>
              <div className="col-12">
 
  <input
    type="text"
    placeholder={t("username")}
    className="form-control"
    value={userName}
    onChange={(e) => setUserName(e.target.value)}
    style={submit && userName.length === 0 ? { borderColor: 'red' } : {}}
  />
  {submit && userName.length === 0 && (
     <div className="text-danger">{t("userRequired")}</div>
  )}
</div>

            {/* Password */}
            <div className="col-12">
                    
                      <div className="password-input-wrapper position-relative">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className="form-control"
                          placeholder={t("password")}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={submit && password.length === 0 ? { borderColor: 'red' } : {}}
                        />
                        <span
                          className="toggle-password position-absolute end-0 top-50 translate-middle-y me-3"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: 'pointer' }}
                        >
                          <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye login-eye'}`} />
                        </span>
                      </div>
                      {submit && password.length === 0 && <div className="text-danger">{t("passRequired")}</div>}
                    </div>

                    {/* <div className="col-md-12 mt-4">
                      <select
  className="form-control custom-input"
  onChange={handleLangChange}
>
 < option disabled value="Select Language">Select Language</option>
  <option value="en">English</option>
  <option value="ta">தமிழ்</option>
</select>
                    </div> */}
          

            <button type="submit"  onClick={adminLogin} className="mt-4 sign-in-btn">
             {loading ? t("logging") : t("login")}
            </button>
          </form>
        </div>

        {/* RIGHT PANEL */}
        <div className={`toggle-container ${lang === "ta" && "fs-tamil"}`}>
          <div className="toggle">
            <div className="toggle-panel toggle-right">
              
              <div className="logo mb-4">
                <img
                  src={LoginLogo}
                  alt="logo"
                  className="logo-img"
                />
              </div>

          <div className="multi-language-text">
  <h5 className="title">{t("title")}</h5>
              <p className="subtitle">{t("loginDesc")}</p>

              <div className="output">
                <span>{t("manageText")}</span>
              </div>
</div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}